<mat-form-field class="mat-form-field-no-padding" style="width: 100%; height: auto;" appearance="outline" floatLabel="auto">
    <input style="margin-left: 5px;height: 20px;margin-bottom: 2px;" matInput [(ngModel)]="item.text" placeholder="Enter value" required [formControl]="formControl" [matAutocomplete]="auto">
    <mat-autocomplete #auto="matAutocomplete">
        <mat-option *ngFor="let option of filteredOptions | async" [value]="option">
            {{ option }}
        </mat-option>
    </mat-autocomplete>
    <div matPrefix style="margin-bottom: 2px;" class="colorBox" [style.backgroundColor]="item.color.color"></div>
    <button matSuffix style="margin-left: 10px;height: 20px;margin-bottom: 2px;" mat-icon-button>
        <mat-icon class="icon red-icon" (click)="onDeleteItem(item)">delete_forever</mat-icon>
    </button>
</mat-form-field>